// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"mE-z","smallCardRow":"nE-z","largeCardRow":"oE-z","productSearchRow":"pE-z","curatedRow":"qE-z"};